export const base_url = "https://asianco-app-asvm.onrender.com/api/";
//export const base_url = "http://localhost:5001/api/";

